import { render, staticRenderFns } from "./exhibition-business.vue?vue&type=template&id=ba3194fa&scoped=true&"
import script from "./exhibition-business.vue?vue&type=script&lang=js&"
export * from "./exhibition-business.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-business.vue?vue&type=style&index=0&id=ba3194fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3194fa",
  null
  
)

export default component.exports